<template>
  <v-card>
    <v-card-title class="secondary--text">{{title}}</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <warehouse-select
              class="rounded-lg"
              :return-object="false"
              label="انبار"
              :items="warehouses"
              v-model="filter_warehouses"
              item-text="title"
              item-value="id"
              multiple
              clearable
              @input="setFilterWithWarehouses"
          >
          </warehouse-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select :menu-props="{ bottom: true, offsetY: true }"
                    class="rounded-lg"
                    :items="wareLevels" v-model="filters.level" label="سطح کالا"/>
        </v-col>
        <v-col cols="12" md="4">
          <v-select :menu-props="{ bottom: true, offsetY: true }"
                    class="rounded-lg"
                    :items="waresStatuses" v-model="filters.status" label="وضعیت کالا"></v-select>
        </v-col>

        <v-col cols="12">
          <m-datatable :api-url="url" :headers="headers" :filters.sync="filters" ref="datatable"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import wareApiMixin from "@/mixin/wareApi";
import _ from "lodash";
import WarehouseSelect from "@/components/selects/WarehouseSelect";

export default {
  mixins: [wareApiMixin],
  components: {WarehouseSelect },
  props: ["warehouseId"],
  data() {
    return {
      filter_warehouses: [0],

      url: "reports/inventory/warehouse/all",
      warehouse: null,
      filters: {
        warehouse: null,
        status: 'withTransaction',
        level: 3,
      },
      headers: [
        {
          text: "کد",
          value: "code",
        },
        {
          text: "نام",
          value: "name",
        },
        {
          text: "واحد",
          value: "unit",
          sortable: false,
          filterable: false,
        },
        {
          text: "وارده",
          value: "input",
          type: "numeric",
          filterable: false,
        },
        {
          text: "صادره",
          value: "output",
          type: "numeric",
          filterable: false,
        },
        {
          text: "مانده",
          value: "remain",
          type: "numeric",
          filterable: false,
        },
        //{
        //  text: "انبار",
        //  value: "warehouse_name",
        //  filterable: false,
        //},

      ],
    };
  },
  created() {
    this.getWarehouses();
  },
  methods: {
    setFilterWithWarehouses() {
      let warehouses_string = this.filter_warehouses.join(",");
      if (warehouses_string != "0") {
        this.filters.warehouse_in = warehouses_string;
      } else {
        this.filters.warehouse_in = undefined;
      }
      this.$refs.datatable.getDataFromApi();
    },
  },
  computed: {
    title() {
      return this.setDocumentTitle('کاردکس انبار همه کالا ها')
    }
  },


};
</script>

<style scoped lang="scss">
</style>
